<p-dialog
  [visible]="mode && mode.isOn"
  (visibleChange)="mode && (mode.isOn = $event)"
  modal="modal"
  [style]="{ width: '100%', height: '516px' }"
  [responsive]="true"
  (onHide)="onClose()"
>
  <div>
    <div>{{ 'label.Customer' | translate }}</div>
    <div>
      <p-autoComplete
        forceSelection="true"
        [ngModel]="payment && payment.payerAccount"
        (ngModelChange)="payment && (payment.payerAccount = $event)"
        [size]="300"
        [suggestions]="accountList"
        (completeMethod)="filterAccount($event)"
        appendTo="body"
        (onSelect)="onPayerSelect($event)"
        [minLength]="1"
        field="displayName"
        [inputStyle]="{ width: '100%' }"
        [disabled]="mode && mode.edit"
      >
        <ng-template let-account pTemplate="item">
          <span
            >{{ account.customer?.legalName }} ({{
              account.customer?.idNumber
            }})</span
          >
        </ng-template>
      </p-autoComplete>
      <hr-field-state-marker [field]="field?.payer"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.Amount' | translate }}</div>
    <div>
      <hr-money-input
        [ngModel]="payment && payment.amount"
        (ngModelChange)="
          payment && (payment.amount = $event ?? null) && onAmountChange()
        "
      ></hr-money-input>
      <hr-field-state-marker [field]="field?.amount"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.Date' | translate }}</div>
    <div>
      <p-datepicker
        [ngModel]="payment && payment.paymentDate"
        (ngModelChange)="payment && (payment.paymentDate = $event)"
      ></p-datepicker>
      <hr-field-state-marker
        [field]="field?.paymentDate"
      ></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.Invoices' | translate }}</div>
    <div>
      <p-autoComplete
        forceSelection="true"
        [size]="300"
        [disabled]="
          payment?.payerAccount == null ||
          payment.payerAccount?.accountId == null
        "
        [ngModel]="payment && payment.activeInvoiceCoverages"
        (ngModelChange)="payment && (payment.activeInvoiceCoverages = $event)"
        [suggestions]="invoiceCoverageList"
        (completeMethod)="filterInvoice($event)"
        [minLength]="1"
        field="displayName"
        dataKey="key"
        [multiple]="true"
        [inputStyle]="{ width: '100%' }"
        (onSelect)="onInvoiceSelect($event)"
        (onUnselect)="onInvoiceUnselect($event)"
      >
        <ng-template let-invoiceCoverage pTemplate="item">
          <span>{{ invoiceCoverage.invoice.code }}</span>
        </ng-template>
      </p-autoComplete>
      <hr-field-state-marker [field]="field?.invoices"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.AmountLeft' | translate }}</div>
    <div style="padding-top: 5px">
      {{ payment?.amountLeft | number : '1.2-2' }}
    </div>
  </div>
  <textarea
    maxlength="250"
    placeholder="{{ 'label.Comment' | translate }}"
    class="comment"
    [ngModel]="payment && payment.comment"
    (ngModelChange)="payment && (payment.comment = $event)"
  ></textarea>
  <ng-template #footer>
    <div style="text-align: center">
      <p-button
        type="button"
        (click)="onSave()"
        label="{{ 'label.Add' | translate }}"
      ></p-button>
      <p-button
        type="button"
        (click)="onClose()"
        label="{{ 'label.Cancel' | translate }}"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
